module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bed-dc771625658d299d03579d1d70bc0e8e.svg";